import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CoreConfigService } from '@core/services/config.service';

@Component({
  selector: 'app-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.scss']
})
export class ReferralComponent implements OnInit, OnDestroy {
  referralCode: string = '';
  appOpened: boolean = false;
  showFallback: boolean = false;
  public coreConfig: any;
  private fallbackTimeout: any;

  constructor(
    private route: ActivatedRoute,
    private _coreConfigService: CoreConfigService
  ) {
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

  ngOnInit(): void {
    this._coreConfigService.config.subscribe(config => {
      this.coreConfig = config;
    });

    this.referralCode = this.route.snapshot.queryParamMap.get('code') || '';
    if (this.referralCode) {
      this.redirectToApp();
    }
  }

  ngOnDestroy(): void {
    if (this.fallbackTimeout) {
      clearTimeout(this.fallbackTimeout);
    }
  }

  redirectToApp(): void {
    const deepLink = `utrav://referral?code=${this.referralCode}`;

    // Redirection immédiate vers le deep link
    window.location.href = deepLink;

    // Afficher les options de fallback après 2 secondes si l'app ne s'ouvre pas
    this.fallbackTimeout = setTimeout(() => {
      this.showFallback = true;
    }, 2000);
  }

  openAppStore(): void {
    window.location.href = 'https://apps.apple.com/app/utrav/6756850786';
  }

  openPlayStore(): void {
    window.location.href = 'https://play.google.com/store/apps/details?id=com.myofficeapps.utrav';
  }
}
